"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _PageContent = _interopRequireDefault(require("./PageContent"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _color = _interopRequireDefault(require("../../constants/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function Page(_ref) {
  var children = _ref.children,
      backgroundColor = _ref.backgroundColor;
  var styles = ['co-page', backgroundColor];
  return _react.default.createElement(_styler.default, {
    classNames: styles
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

Page.propTypes = {
  /** {---} Sequence of: @@<Header>@@ (optional, max: 1), @@<Page.Content>@@ (required, max: 1), @@<Footer>@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,

  /** {const} One of: @@Color.background.white@@, @@Color.background.gray[200]@@ */
  backgroundColor: (0, _propTypes.oneOf)([_color.default.background.gray[200], _color.default.background.white])
};
Page.Content = _PageContent.default;
var _default = Page;
exports.default = _default;
Page.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Page",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Header>@@ (optional, max: 1), @@<Page.Content>@@ (required, max: 1), @@<Footer>@@ (optional, max: 1)"
    },
    "backgroundColor": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "Color.background.gray[200]",
          "computed": true
        }, {
          "value": "Color.background.white",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} One of: @@Color.background.white@@, @@Color.background.gray[200]@@"
    }
  }
};